import React, { Fragment, useState } from "react";

import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Popover from "@mui/material/Popover";
import _ from "lodash";
import DeleteOutline from "mdi-material-ui/DeleteOutline";

import DialogModal from "@core/components/dialogmodal";
import QuickSearchToolbar from "views/components/QuickSearchToolbar";
import moment from "moment";
import { isPermissionAllow } from "@core/utils/IsPermissionAllow";

const renderClient = (params) => {
  const { row } = params;

  if (row.document) {
    return <img alt="img" src={`${row.document}`} width="40px" height="40px" />;
  }
};

const FeedbackList = (props) => {
  const {
    feedbackList,
    pageSize,
    pageNumber,
    setPageSize,
    setPageNumber,
    totalRecord,
    handleConfirmChange,
    deleteOpen,
    handleDeleteModal,
    permission,
    role,
  } = props;

  const theme = useTheme();

  const [deleteId, setDeleteId] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectId, setSelectId] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleDelete = (id) => {
    handleDeleteModal();
    setDeleteId(id);
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleClick = (id) => (event) => {
    setAnchorEl(event.currentTarget);
    setSelectId(id);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const openTooltipModal = (params) => {
    return (
      <>
        <Typography
          sx={{
            fontSize: "0.95rem !important",
            cursor: "pointer",
            textAlign: "left",
          }}
          onClick={handleClick(params?.row?.id)}
        >
          {params?.row?.message}
        </Typography>

        {selectId === params?.row?.id && (
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            sx={{ width: "80%" }}
          >
            <Typography sx={{ p: 2 }}>{params?.row?.message}</Typography>
          </Popover>
        )}
      </>
    );
  };

  const columns = [
    {
      flex: 0.4,
      minWidth: 80,
      field: "index",
      headerName: "Index",
    },
    {
      flex: 1,
      minWidth: 130,
      field: "name",
      headerName: "name",
      renderCell: ({ row }) => {
        return (
          <Box>
            {row?.first_name && (
              <Typography sx={{ fontSize: "0.9rem !important" }}>
                {row.first_name + " " + (row?.last_name ? row?.last_name : "")}
              </Typography>
            )}
          </Box>
        );
      },
    },
    {
      flex: 0.8,
      minWidth: 120,
      field: "feedback_type_name",
      headerName: "Feedback Type",
      renderCell: ({ row }) => {
        return (
          <Typography sx={{ fontSize: "0.9rem !important" }}>
            {row.feedback_type_name || row.type}
          </Typography>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "message",
      headerName: "message",
      renderCell: (params) => {
        return openTooltipModal(params);
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "created_at",
      headerName: "Date",
      renderCell: ({ row }) => {
        const formatDate = moment(row.created_at).format("DD-MM-yyyy hh:mm A");
        return (
          <Typography sx={{ fontSize: "0.9rem !important" }}>
            {formatDate}
          </Typography>
        );
      },
    },
    {
      flex: 1,
      minWidth: 80,
      field: "document",
      headerName: "document",
      renderCell: (params) => {
        return (
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => {
              openInNewTab(params?.row?.document);
            }}
          >
            {renderClient(params)}
          </Box>
        );
      },
    },
    {
      flex: 0.7,
      minWidth: 100,
      field: "status",
      headerName: "status",
      renderCell: (params) => {
        const status = params.row.status;
        const id = params.row.id;
        const check = status === 0 ? false : true;
        return (
          <Box>
            <Button
              type="reset"
              variant="contained"
              size="small"
              onClick={() => handleConfirmChange(id)}
              style={{
                backgroundColor: check
                  ? theme.palette.primary.light
                  : theme.palette.text.disabled,
              }}
            >
              {check ? "pending" : "closed"}
            </Button>
          </Box>
        );
      },
    },
    {
      flex: 0.7,
      minWidth: 100,
      field: "action",
      headerName: "Actions",
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              {((permission.delete && role === "2") || role === "1") && (
                <IconButton onClick={() => handleDelete(row.id)}>
                  <DeleteOutline fontSize="medium" />
                </IconButton>
              )}
            </Box>
          </Box>
        );
      },
    },
  ];
  const removeaction =
    !permission.edit && !permission.delete && role === "2"
      ? _.dropRight(columns)
      : columns;
  const assemList = feedbackList.map((data, index) => {
    return {
      index: index + pageSize * pageNumber + 1,
      id: data.id,
      type: data.type,
      title: data.title,
      message: data.message,
      document: data.document,
      created_at: data.created_at,
      status: data.status,
      feedback_type_id: data.feedback_type_id,
      feedback_type_name: data.feedback_type_name,
      user_id: data.user_id,
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email,
    };
  });

  return (
    <Fragment>
      <Card sx={{ width: "100%", overflowInline: "hidden" }}>
        <DataGrid
          hideFooterSelectedRowCount
          autoHeight
          localeText={{ noRowsLabel: "No results found" }}
          columns={removeaction}
          rows={assemList}
          pageSize={pageSize}
          rowsPerPageOptions={[10, 25, 50]}
          components={{ Toolbar: QuickSearchToolbar }}
          onPageChange={(newPageNumber) => setPageNumber(newPageNumber)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          onSelectionModelChange={(rows) => setSelectedRows(rows)}
          pagination
          rowCount={Number(totalRecord)}
          page={pageNumber}
          paginationMode="server"
          checkboxSelection={isPermissionAllow(permission.delete, role)}
          disableSelectionOnClick
          componentsProps={{
            toolbar: {
              selectedRows: selectedRows,
              onClickDelete: () => handleDeleteModal(),
              isSearch: false,
              clearSearch: () => {},
              onChange: (event) => {},
              multiDelete: isPermissionAllow(permission.delete, role),
            },
          }}
          sx={{
            ".MuiTablePagination-displayedRows": {
              marginTop: "1rem",
            },
            ".MuiTablePagination-selectLabel": {
              marginTop: "1.1rem",
            },
            ".MuiInputBase-root": {
              marginTop: "0.2rem",
            },
          }}
        />
      </Card>

      {deleteOpen && (
        <DialogModal
          open={deleteOpen}
          handleClose={() => handleDeleteModal()}
          handleDelete={() =>
            handleDeleteModal(
              selectedRows && selectedRows.length === 0
                ? [deleteId]
                : selectedRows,
            )
          }
        />
      )}
    </Fragment>
  );
};

export default FeedbackList;
